/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPageSideMenuViewerFragmentDoc, SettingsPageSideMenuContractFragmentDoc } from './SettingsPageSideMenu.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ContractType =
  | 'CORPORATE'
  | 'INDIVIDUAL'
  | 'UNKNOWN';

export type PaymentMethod =
  | 'STRIPE'
  | 'UNKNOWN';

export type StaffRole =
  | 'BRANCH_MANAGER'
  | 'CORPORATION_ADMIN'
  | 'ENTRANCE_MANAGER'
  | 'MEMBER';

export type SettingsPagePlannerFragment = { id: string, name: string, slug: string, avatar: any, avatarUrl: string, cover: any, coverUrl: string | null, corporationId: string, branchIds: Array<string>, email: string, gender: string, birthday: DateString | null, availableTime: string, availableAreaCodes: Array<string>, role: string, comment: string, authorities: Array<string>, specialties: Array<{ id: string, name: string }> };

export type SettingsPagePlannerSpecialtyFragment = { id: string, name: string };

export type SettingsPageUiControlFragment = { editCorporation: boolean, editStaffs: boolean, useLineMessageFeatures: boolean };

export type SettingsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageQuery = { contract: { contractType: Types.ContractType, paymentMethod: Types.PaymentMethod } | null, viewer: { id: string, myStoryUrl: string | null, hasLineActivationProvider: boolean, profile: { name: string, avatar: any, reviewScore: number }, autoPostKartePlannerComment: { available: boolean }, attackListSender: { available: boolean }, staff: { role: Types.StaffRole } }, planner: { id: string, name: string, slug: string, avatar: any, avatarUrl: string, cover: any, coverUrl: string | null, corporationId: string, branchIds: Array<string>, email: string, gender: string, birthday: DateString | null, availableTime: string, availableAreaCodes: Array<string>, role: string, comment: string, authorities: Array<string>, specialties: Array<{ id: string, name: string }> } | null, uiControl: { editCorporation: boolean, editStaffs: boolean, useLineMessageFeatures: boolean } };

export const SettingsPagePlannerFragmentDoc = gql`
    fragment SettingsPagePlanner on Planner {
  id
  name
  slug
  avatar
  avatarUrl
  cover
  coverUrl
  corporationId
  branchIds
  email
  gender
  birthday
  availableTime
  availableAreaCodes
  role
  comment
  specialties {
    id
    name
  }
  authorities
}
    `;
export const SettingsPagePlannerSpecialtyFragmentDoc = gql`
    fragment SettingsPagePlannerSpecialty on PlannerSpecialty {
  id
  name
}
    `;
export const SettingsPageUiControlFragmentDoc = gql`
    fragment SettingsPageUIControl on UIControl {
  editCorporation
  editStaffs
  useLineMessageFeatures
}
    `;
export const SettingsPageDocument = gql`
    query SettingsPage {
  contract {
    ...SettingsPageSideMenuContract
  }
  viewer {
    ...SettingsPageSideMenuViewer
  }
  planner {
    ...SettingsPagePlanner
  }
  uiControl {
    ...SettingsPageUIControl
  }
}
    ${SettingsPageSideMenuContractFragmentDoc}
${SettingsPageSideMenuViewerFragmentDoc}
${SettingsPagePlannerFragmentDoc}
${SettingsPageUiControlFragmentDoc}`;

/**
 * __useSettingsPageQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageQuery();
 */
export function useSettingsPageQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageQuery, SettingsPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageQuery, SettingsPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageQuery, SettingsPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageQuery, SettingsPageQueryVariables>(SettingsPageDocument, {}, options);
}
export function useSettingsPageLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageQuery, SettingsPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageQuery, SettingsPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageQuery, SettingsPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageQuery, SettingsPageQueryVariables>(SettingsPageDocument, {}, options);
}
export type SettingsPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageQuery, SettingsPageQueryVariables>;